import { makeStyles } from '@fluentui/react-components';
import { themedAvatarRule } from './avatarTheme';

const useStyles = makeStyles({ avatar: themedAvatarRule });

export const useThemedAvatar = (): string => useStyles().avatar;
